import { graphql, useStaticQuery } from 'gatsby';

export default function ERPMenuLinks() {
  const ERPMenu = useStaticQuery(graphql`
    query MyErpQuery {
      allMenuLinkContentErp {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return ERPMenu;
}
